export default [
  {
    path: '/hotel/list',
    name: 'hotel-list',
    component: () => import('@/views/hotel/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel List',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Hotel' },
        { title: 'Hotel List', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/hotel/bookings',
    name: 'global-hotel-bookings',
    component: () => import('@/views/hotel/HotelBookings.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Bookings',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Hotel' },
        { title: 'Hotel Bookings', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/hotel/add',
    name: 'create-hotel-global',
    component: () => import('@/views/hotel/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Hotel',
      parent: 'HotelList',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Hotel', url: '/hotel/list' },
        { title: 'Add Hotel', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/hotel/view/:hotelId',
    name: 'hotel-details-global',
    component: () => import('@/views/hotel/HotelDetailsView.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Details',
      parent: 'HotelList',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Hotel', url: '/hotel/list' },
        { title: 'Hotel Details', active: true }
      ],
      roles: ['admin', 'hotel-manager', 'superadmin', 'support-administrator']
    }
  },
  {
    path: '/hotel/:id/edit',
    name: 'edit-hotel-global',
    component: () => import('@/views/hotel/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Hotel',
      parent: 'HotelList',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Hotel', url: '/hotel/list' },
        { title: 'Edit Hotel', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/hotel/bookings',
    name: 'hotel-bookings',
    component: () => import('@/views/hotel/HotelBookings.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Bookings',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Hotel Bookings', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/hotel/add',
    name: 'add-hotel',
    component: () => import('@/views/hotel/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Hotel',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Add Hotel', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/hotel/:hotelId/view',
    name: 'hotel-details-gurudwara',
    component: () => import('@/views/hotel/HotelDetailsView.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Details',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Hotel Details', active: true }
      ],
      roles: ['admin', 'hotel-manager', 'superadmin', 'support-administrator']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/hotel/:hotelId/edit',
    name: 'edit-hotel',
    component: () => import('@/views/hotel/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Hotel',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Edit Hotel', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/hotel/:hotelId/dashboard',
    name: 'gurudwara-hotel-dashboard',
    component: () => import('@/views/hotel/HotelDashboard.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Dashboard',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Hotel Dashboard', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/hotel/:hotelId/rooms',
    name: 'hotel-room-management',
    component: () => import('@/views/hotel/RoomManagement.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Room Management',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Room Management', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/hotel/:hotelId/managers',
    name: 'hotel-managers',
    component: () => import('@/views/hotel/HotelManager.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Managers',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Hotel', url: '/hotel/list' },
        { title: 'Hotel Managers', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/hotel/:hotelId/dashboard',
    name: 'hotel-dashboard-detail',
    component: () => import('@/views/hotel/HotelDashboard.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Dashboard',
      breadcrumb: [
        { title: 'Dashboard', url: '/' },
        { title: 'Hotel', url: '/hotel/list' },
        { title: 'Hotel Dashboard', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/hotel/:hotelId/managers',
    name: 'gurudwara-hotel-managers',
    component: () => import('@/views/hotel/HotelManager.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Managers',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Hotel Managers', active: true }
      ],
      roles: ['superadmin', 'admin', 'hotel-manager']
    }
  }
]
